import React from 'react'
import { HostServices } from '@ally/federated-types'
import { LoadState } from '@ally/use-data-domain'
import { HostData, Domains } from '@ally/data-types-host'
import { noop } from './utils'

export const defaultHostData: HostData = {
  [Domains.TRANSFER_ACCOUNTS]: {
    data: null,
    error: null,
    status: { loadState: LoadState.UNLOADED, timeStamp: new Date() },
    update: (): void => {
      /* noop */
    },
    response: null,
  },
} as HostData

export const defaultHostServices = (): HostServices =>
  ({
    hostData: defaultHostData,
    log: {
      track: noop,
      log: noop,
      error: noop,
      warn: noop,
      info: noop,
      debug: noop,
      trace: noop,
      child: noop,
    },
  } as HostServices)

export const HostServicesContext = React.createContext<HostServices>(
  defaultHostServices(),
)

export function useHostServices(): HostServices {
  return React.useContext(HostServicesContext)
}
